var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-sort-container" },
    [
      _c(
        "div",
        { staticClass: "scene-control-card" },
        [
          _c(
            "el-card",
            { attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("i", { staticClass: "el-icon-setting" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("场景选择")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "medium" },
                  on: { change: _vm.handleSceneChange },
                  model: {
                    value: _vm.currentScene,
                    callback: function ($$v) {
                      _vm.currentScene = $$v
                    },
                    expression: "currentScene",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: 1 } }, [
                    _vm._v("堂食"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: 2 } }, [
                    _vm._v("自提"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: 3 } }, [
                    _vm._v("外卖"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "default-sort-card" },
        [
          _c("el-card", { attrs: { shadow: "hover" } }, [
            _c(
              "div",
              {
                staticClass: "card-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [
                _c(
                  "div",
                  { staticClass: "header-left" },
                  [
                    _c("i", { staticClass: "el-icon-s-operation" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("默认排序")]),
                    _vm._v(" "),
                    _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { size: "mini", type: "success" },
                      },
                      [_vm._v("基础基准")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-sort",
                    },
                    on: { click: _vm.handleSortDefaultGroups },
                  },
                  [_vm._v("\n          调整默认排序\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "default-sort-body" }, [
              _c("div", { staticClass: "default-sort-tip" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("未命中任何设定时段时，系统将自动恢复为此默认排序。"),
                ]),
              ]),
              _vm._v(" "),
              _vm.defaultSortConfig &&
              _vm.defaultSortConfig.details &&
              _vm.defaultSortConfig.details.length > 0
                ? _c(
                    "div",
                    { staticClass: "group-tags-wrap" },
                    _vm._l(
                      _vm.defaultSortConfig.details,
                      function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.id || index,
                            staticClass: "group-tag-item",
                          },
                          [
                            _c("span", { staticClass: "tag-badge" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "tag-title" }, [
                              _vm._v(
                                _vm._s(
                                  item.groupName ||
                                    _vm.getGroupName(item.menuTemplateGroupId)
                                )
                              ),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "empty-default-text" }, [
                    _vm._v(
                      "\n          暂无分组数据，点击“调整默认排序”进行设置\n        "
                    ),
                  ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-list-card" },
        [
          _c(
            "el-card",
            { attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "header-left" }, [
                    _c("i", { staticClass: "el-icon-time" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("分时段排序配置")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-sub-tip" }, [
                      _vm._v(
                        "（在设定时段内覆盖默认排序，超出时段自动恢复默认排序）"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.handleAddConfig },
                    },
                    [_vm._v("\n          添加时段配置\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.configList, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "开始时间",
                      prop: "beginTime",
                      align: "center",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatTime(row.beginTime)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "结束时间",
                      prop: "endTime",
                      align: "center",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatTime(row.endTime)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "分组数量", align: "center", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.details ? row.details.length : 0) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      "min-width": "300",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  icon: "el-icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEditConfig(row)
                                  },
                                },
                              },
                              [_vm._v("\n              编辑\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-sort",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSortGroups(row)
                                  },
                                },
                              },
                              [_vm._v("\n              调整排序\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDeleteConfig(row)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading && _vm.configList.length === 0
                ? _c("div", { staticClass: "empty-text" }, [
                    _vm._v(
                      "\n        暂无时段配置，当前全天生效默认排序\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogForm.id ? "编辑配置" : "添加时段配置",
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogFormRef",
              attrs: {
                model: _vm.dialogForm,
                rules: _vm.dialogRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开始时间", prop: "beginTime" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      format: "HH:mm",
                      "value-format": "timestamp",
                      placeholder: "选择开始时间",
                    },
                    model: {
                      value: _vm.dialogForm.beginTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "beginTime", $$v)
                      },
                      expression: "dialogForm.beginTime",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "结束时间", prop: "endTime" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      format: "HH:mm",
                      "value-format": "timestamp",
                      placeholder: "选择结束时间",
                    },
                    model: {
                      value: _vm.dialogForm.endTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "endTime", $$v)
                      },
                      expression: "dialogForm.endTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSaveConfig },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isSortingDefault
              ? "调整默认分组排序"
              : "调整分时段分组排序",
            visible: _vm.sortDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.sortDialogVisible = $event
            },
            closed: _vm.handleSortDialogClosed,
          },
        },
        [
          _c("div", { staticClass: "sort-container" }, [
            _c("div", { staticClass: "sort-tip" }, [
              _c("i", { staticClass: "el-icon-info" }),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.isSortingDefault
                      ? "拖动分组可调整默认排序，未命中任何设定时段时将生效此排序。点击保存后生效。"
                      : "拖动分组可调整该时段内的顺序，点击保存后生效。"
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { ref: "sortList", staticClass: "sort-list" },
              _vm._l(_vm.sortList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "sort-item",
                    attrs: { "data-id": item.id },
                  },
                  [
                    _c("i", { staticClass: "el-icon-rank sort-handle" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sort-index" }, [
                      _vm._v(_vm._s(index + 1) + "."),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sort-name" }, [
                      _vm._v(
                        _vm._s(
                          item.groupName ||
                            _vm.getGroupName(item.menuTemplateGroupId)
                        )
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sortDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSaveSort },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }